import { render, staticRenderFns } from "./MedicineForm.vue?vue&type=template&id=016b10f2&"
import script from "./MedicineForm.vue?vue&type=script&lang=js&"
export * from "./MedicineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports